<template>
  <div class="row">
    <div class="col-md-12">
      <form>
        <card>
          <div slot="header">
            <h4 class="card-title">SI帳號</h4>
          </div>
          <div>
            <fg-input
              label="名稱"
              required
              v-model="model.name"
              v-validate="modelValidations.name"
              :error="getError('full name')"
              name="full name"
            ></fg-input>

            <template v-if="model.isModified === ''">
              <fg-input
                label="Email address"
                required
                v-model="model.email"
                v-validate="modelValidations.email"
                :error="getError('email')"
                name="email"
                type="email"
              ></fg-input>

              <fg-input
                label="Passowrd"
                required
                name="password"
                v-model="model.password"
                v-validate="modelValidations.password"
                :error="getError('password')"
                type="password"
              ></fg-input>
            </template>  

          </div>
          <div class="d-flex justify-content-center">
            <n-button v-if="model.isModified === ''" native-type="submit" @click.native.prevent="validate" type="primary">新增SI帳號</n-button>
            <n-button v-else native-type="submit" @click.native.prevent="validate" type="primary">修改SI名稱</n-button>
          </div>
           
        </card>
      </form>

      <!-- small modal -->
      <modal :show.sync="modals.mini"
              class="modal-danger"
              :show-close="false"
              headerClasses="justify-content-center"
              type="mini">
        <div slot="header" class="modal-profile">
          <i class="now-ui-icons ui-1_simple-remove"></i>
        </div>
        <p><strong>{{modals.content}}</strong></p>
        <template slot="footer">
          <!-- <n-button type="neutral" link>Back</n-button> -->
          <n-button type="neutral" link @click.native="modals.mini = false">Close</n-button>
        </template>
      </modal>
    </div>
  </div>


</template>
<script>
import axios from "axios";
import { Checkbox, Radio } from "src/components/index";
import { Modal } from 'src/components';
// import CryptoJS from "crypto-js";

export default {
  components: {
    Checkbox,
    Radio,
    Modal
  },
  // computed: {
  //   userId: function() {
  //     console.log("the user Id is ", this.$store.getters.userId);
  //     // Encrypt 加密
  //     // var cipherText = CryptoJS.AES.encrypt(
  //     //   "my message",
  //     //   "secretkey123"
  //     // ).toString();
  //     // console.log(cipherText)
  //     // // Decrypt 解密
  //     // var bytes = CryptoJS.AES.decrypt(cipherText, "secretkey123");
  //     // var originalText = bytes.toString(CryptoJS.enc.Utf8);
  //     // console.log(originalText); // 'my message'
  //     return this.$store.getters.userId;
  //   }
  // },
  data() {
    return {
      model: {
        email: "",
        password: "",
        name: "",
        isModified: ""
      },
      modelValidations: {
        name: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        password: {
          required: true,
          min: 5
        }
      },
      modals: {
        content: '',
        mini: false
      }
    };
  },
  computed: {
    userType: function() {
      return this.$store.getters.userType;
    }
  },
  mounted() {
    let self = this;
    if (this.$route.params.siId) {
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/gaa/si-accounts/`
        )
        .then(response => {
          // self.model.email = response.data.email;
          let siAccountsArray = response.data;
          let siName = "";
          siAccountsArray.forEach(element => {
            let siId = element.id;
            // console.log('siId: ', siId);
            let routeParamSiId = parseInt(this.$route.params.siId);
            // console.log('route siId: ', routeParamSiId);

            if (siId === routeParamSiId) {
              siName = element.name;
              console.log('element: ', siId, siName);
            }
          });
          self.model.name = siName;
          self.model.isModified = 'true';
          // console.log('response.data: ', response.data);
          console.log('self.model.name: ', self.model.name);
          console.log('self.userType: ', self.userType);

          return response.data;
        })
        .catch(e => {
          if (e && e.data && e.data.message)
            this.modals.content = e.data.message;

          this.modals.mini = true;
        });
    }
  },
  methods: {
    validate() {
      let self = this;
      this.$validator.validateAll().then(isValid => {
        this.$emit("on-submit", this.registerForm, isValid);

        if (isValid) {
          if (this.$route.params.siId) {
            // putApi
            let putApi = '';
            if (self.userType === 'gaa')
              // putApi
              putApi = `${process.env.VUE_APP_APIHOST}/gaa/si-accounts/${self.$route.params.siId}`
              console.log('PUT API: ', putApi)
            return axios
              .put(
                putApi,
                {
                  name: this.model.name,
                  // status: "disabled"
                }
              )
              .then(response => {
                if (response && response.data) {
                  this.$router.push("/si-accounts");
                } else {
                  console.log('response: ', response, response.data);
                  this.modals.content = "修改帳號發生問題";
                  this.modals.mini = true;
                }
                return response.data;
              })
              .catch(e => {
                if (e && e.data && e.data.message)
                  this.modals.content = e.data.message;
                  console.log('Error: ', e);
                this.modals.mini = true;
              });
          } else {
            return axios
            .post(`${process.env.VUE_APP_APIHOST}/gaa/si-accounts/`, {
              email: this.model.email,
              name: this.model.name,
              password: this.model.password
            })
            .then(response => {
              if (response && response.data && response.data.accountId) {
                this.$router.push("/si-accounts");
              } else {
                this.modals.content = '建立帳號發生錯誤';
                this.modals.mini = true;
              }
              return response.data;
            })
            .catch(e => {
              
              if (e && e.data && e.data.message)
                this.modals.content = e.data.message;

              this.modals.mini = true;
            });
          }
        } else {
          console.log("validate failed");
        }
        // if (isValid) {
        //   return axios
        //     .post(`${process.env.VUE_APP_APIHOST}/gaa/si-accounts/`, {
        //       email: this.model.email,
        //       name: this.model.name,
        //       password: this.model.password
        //     })
        //     .then(response => {
        //       if (response && response.data && response.data.accountId) {
        //         this.$router.push("/si-accounts");
        //       } else {
        //         this.modals.content = '建立帳號發生錯誤';
        //         this.modals.mini = true;
        //       }
        //       return response.data;
        //     })
        //     .catch(e => {
              
        //       if (e && e.data && e.data.message)
        //         this.modals.content = e.data.message;

        //       this.modals.mini = true;
        //     });
        // } else {
        //   console.log("validate failed");
        // }
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    }
  }
};
</script>
<style>
.card .alert {
  position: relative !important;
  width: 100%;
}
</style>